module.exports = __webpack_public_path__ + "img/yingyong_icon04.298d91c7.png";